// extracted by mini-css-extract-plugin
export default {"titleBar":"TitleBar_titleBar__uZwZc","btnBack":"TitleBar_btnBack__jeDa3","btnInfo":"TitleBar_btnInfo__hG8Di","btnSurvey":"TitleBar_btnSurvey__MCuA3"};